module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-top-stone-path-background-remnants.9cf2d2f5.png";